export default function Footer() {
  return (
    <footer style={{ 
      background: 'var(--black)', 
      color: 'var(--text-color)', 
      padding: '4rem 2rem 2rem',
      borderTop: '1px solid var(--accent)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '3rem',
        justifyContent: 'space-between',
      }}>
        {/* Coluna 1: Logo e breve descrição */}
        <div>
          <h3 style={{
            color: 'var(--accent)', 
            fontSize: '1.4rem',
            marginBottom: '1.2rem',
            position: 'relative',
            paddingBottom: '0.8rem'
          }}>
            Advogados Associados
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '60px',
              height: '3px',
              background: 'var(--accent)'
            }}></span>
          </h3>
          <p style={{lineHeight: '1.6', marginBottom: '1.5rem'}}>
          Advogados especializados em direito do trabalho com mais de 7 anos de experiência na defesa do trabalhador perante à justiça do trabalho e mais de 500 clientes representados.
          </p>
          <div style={{
            display: 'flex', 
            gap: '1rem',
            marginTop: '1.5rem'
          }}>
            {/* Botões de redes sociais */}
            <SocialButton 
              icon="fab fa-whatsapp" 
              url="https://tintim.link/whatsapp/f29b407c-6594-4bba-b0aa-f5442f711a68/e7405481-419a-4fdb-8030-9aee45f67a3a"
              hoverColor="#25D366" 
              ariaLabel="WhatsApp" 
            />
            <SocialButton 
              icon="fa-regular fa-envelope" 
              url="mailto:maikeramos.juridico@gmail.com" 
              hoverColor="#DB4A39" 
              ariaLabel="Email" 
            />
            <SocialButton 
              icon="fab fa-instagram" 
              url="https://www.instagram.com/pfmr.advogadosassociados/?utm_source=ig_web_button_share_sheet" 
              hoverColor="#E1306C" 
              ariaLabel="Instagram" 
            />
          </div>
        </div>
        
        {/* Coluna 2: Informações de contato */}
        <div>
          <h3 style={{
            color: 'var(--accent)', 
            fontSize: '1.4rem',
            marginBottom: '1.2rem',
            position: 'relative',
            paddingBottom: '0.8rem'
          }}>
            Contato
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '60px',
              height: '3px',
              background: 'var(--accent)'
            }}></span>
          </h3>
          
          <div style={{marginBottom: '1rem'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '0.7rem'}}>
              <i className="far fa-envelope" style={{marginRight: '10px', color: 'var(--accent)', width: '20px'}}></i>
              <a href="mailto:maikeramos.juridico@gmail.com" style={{
                color: 'var(--text-color)', 
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--accent)'} 
                 onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-color)'}>
                maikeramos.juridico@gmail.com
              </a>
            </div>
            
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '0.7rem'}}>
              <i className="fas fa-phone-alt" style={{marginRight: '10px', color: 'var(--accent)', width: '20px'}}></i>
              <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
                <a href="tel:+55 15 99715-2102" style={{
                  color: 'var(--text-color)', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--accent)'} 
                   onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-color)'}>
                  (15) 99715-2102
                </a>
                <a href="tel:+55 15 98822-2423" style={{
                  color: 'var(--text-color)', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--accent)'} 
                   onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-color)'}>
                  (15) 98822-2423
                </a>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'center'}}>
              <i className="fas fa-map-marker-alt" style={{marginRight: '10px', color: 'var(--accent)', width: '20px'}}></i>
              <a href="https://maps.app.goo.gl/vQbC5xGkaEoV4Lhb8" target="_blank" rel="noreferrer"
              style={{
                color: 'var(--text-color)', 
                cursor: 'pointer',
                textDecoration: 'none',
                transition: 'color 0.3s ease'
              }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--accent)'} 
                 onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-color)'}>
                Rua Santa Rosália, 276, Sala 1, <br />Sorocaba-SP
              </a>
            </div>
          </div>
        </div>
        
        {/* Coluna 3: Áreas de atuação */}
        <div>
          <h3 style={{
            color: 'var(--accent)', 
            fontSize: '1.4rem',
            marginBottom: '1.2rem',
            position: 'relative',
            paddingBottom: '0.8rem'
          }}>
            Áreas de Atuação
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '60px',
              height: '3px',
              background: 'var(--accent)'
            }}></span>
          </h3>
          
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            {[
              'Direito do trabalho', 
              'Direito previdenciária'
            ].map((area, index) => (
              <li key={index} style={{
                marginBottom: '0.7rem',
                paddingLeft: '15px',
                position: 'relative'
              }}>
                <span style={{
                  position: 'absolute',
                  left: 0,
                  top: '10px',
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: 'var(--accent)'
                }}></span>
                {area}
              </li>
            ))}
          </ul>
        </div>
      </div>
      
      <div style={{
        marginTop: '2rem',
        textAlign: 'center',
        padding: '1.5rem 0 0',
        borderTop: '1px solid var(--accent)',
        opacity: 0.7,
        fontSize: '0.9rem'
      }}>
        <p>&copy; {new Date().getFullYear()} Paulo Ferreira & Maike Ramos</p>
        <p>
          Desenvolvido por <a 
            href="https://www.joaopedrobatistadev.com.br/" 
            target="_blank" 
            rel="noreferrer"
            style={{
              color: 'var(--accent)',
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              position: 'relative',
              padding: '0 2px'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.color = '#ffffff';
              e.currentTarget.style.textShadow = '0 0 5px var(--accent)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.color = 'var(--accent)';
              e.currentTarget.style.textShadow = 'none';
            }}
          >
            João Pedro Batista Dev
          </a>. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}

function SocialButton({ icon, url, hoverColor, ariaLabel }) {
  return (
    <a 
      href={url}
      target="_blank"
      rel="noreferrer"
      style={{
        color: 'var(--accent)', 
        fontSize: '1.2rem', 
        background: 'rgba(255, 255, 255, 0.05)',
        border: 'none',
        padding: '0.5rem',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none'
      }}
      aria-label={ariaLabel}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.color = hoverColor;
        e.currentTarget.style.boxShadow = `0 0 10px ${hoverColor}80`;
        e.currentTarget.style.background = `${hoverColor}20`;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.color = 'var(--accent)';
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
      }}
    >
      <i className={icon}></i>
    </a>
  );
}
